import React, { ReactElement } from 'react';

import gridConfig from 'constants/grid-config';
import { useTranslate } from 'hooks/translate';

import TextInput from 'components/form/text-input/text-input';
import { Col, Row, setConfiguration } from 'react-grid-system';
import DatePicker from 'components/form/datepicker/datepicker';
import { Control, FieldErrors } from 'react-hook-form';

setConfiguration(gridConfig);

interface CompanionFormProps {
  registerRef: (ref: Element | null) => void;
  control: Control<PassengerDeclarationValues>;
  namePrefix: string;
  errors: FieldErrors<PassengerCompanion> | undefined;
  onDelete: () => void;
}

const CompanionForm = ({
  control,
  registerRef,
  onDelete,
  namePrefix,
  errors,
}: CompanionFormProps): ReactElement => {
  const { t } = useTranslate();

  const generateFieldName = (name: string): string => `${namePrefix}.${name}`;

  return (
    <div className='passenger-companion-form'>
      <Row>
        <Col sm={12} md={8}>
          <p>
            <b>{t('reservation.guestInformation.childSpouseInfo')}</b>
          </p>
        </Col>
        <Col sm={12} md={4}>
          <div className='form-action'>
            <button onClick={() => onDelete()}>
              {t('reservation.guestInformation.delete')}
            </button>
          </div>
        </Col>
      </Row>
      <Row>
        <Col sm={12} md={6}>
          <TextInput
            id={generateFieldName('firstName')}
            label={t('reservation.guestInformation.firstName')}
            name={generateFieldName('firstName')}
            error={!!errors?.firstName}
            registerRef={registerRef}
          />
        </Col>
        <Col sm={12} md={6}>
          <TextInput
            id={generateFieldName('lastName')}
            label={t('reservation.guestInformation.lastName')}
            name={generateFieldName('lastName')}
            error={!!errors?.lastName}
            registerRef={registerRef}
          />
        </Col>
      </Row>
      <DatePicker
        label={t('reservation.guestInformation.dateOfBirth')}
        name={generateFieldName('dateOfBirth')}
        error={!!errors?.dateOfBirth}
        control={control}
        value={new Date()}
        max={new Date()}
      />
    </div>
  );
};

export default CompanionForm;
